<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div class="mobile-menu" [class.open]="isOpen">
    <ul class="menumb__container">
        <li
            *ngFor="let item of menuItems; let i = index"
            class="menumb__option__cont"
        >
            <div
                *ngIf="item.subMenu"
                class="menu__option__haschild submenu-option"
                (click)="toggleSubMenu(i)"
            >
                <button class="menumb__option__link">
                    {{ item.label | translate }}
                </button>
                <span class="material-symbols-outlined arrow-submenumb">
                    {{
                        item.isOpen
                            ? 'keyboard_arrow_up'
                            : 'keyboard_arrow_down'
                    }}
                </span>
            </div>
            <ul [class.openSubmenu]="item.isOpen" class="submenumb__container">
                <li
                    *ngFor="let subItem of item.subMenu"
                    class="submenumb__option__cont"
                >
                    <a
                        class="submenumb__option__link"
                        href="{{ subItem.link | formatUrl }}"
                    >
                        {{ subItem.label | translate }}
                    </a>
                    <i class="arrow-link" *ngIf="item.arrowIcon"></i>
                </li>
            </ul>
            <div *ngIf="!item.subMenu">
                <a
                    class="menumb__option__link"
                    [attr.href]="
                        item.extern ? item.link : (item.link | formatUrl)
                    "
                >
                    {{ item.label | translate }}
                </a>
            </div>
        </li>
        <li class="menumb__option__cont">
            <div
                class="menu__option__haschild submenu-option"
                (click)="toggleSubmenuLang()"
            >
                <span class="menumb__option__link language">
                    <i class="bi bi-globe"></i>
                    {{ currentLangtxt }}
                </span>
                <span class="material-symbols-outlined arrow-submenumb">
                    {{
                        menuLangOpen
                            ? 'keyboard_arrow_up'
                            : 'keyboard_arrow_down'
                    }}
                </span>
            </div>
            <ul class="submenumb__container" [class.openSubmenu]="menuLangOpen">
                <li class="submenumb__option__cont">
                    <a
                        class="submenumb__option__link"
                        aria-hidden="true"
                        [attr.href]="
                            [
                                env.baseUrl,
                                currentLanguage === 'en' ? 'es' : 'en'
                            ].join('/')
                        "
                    >
                        {{ idiomaChange }}
                    </a>
                </li>
            </ul>
        </li>
    </ul>
</div>
